import { supabase } from '@/shared/lib/supabase';

/**
 * customerActivityService — read the calling customer's own audit_log rows.
 * RLS policy `audit_log_select_own` (customer_id = auth.uid()) does the gate.
 */

export type ActivityEntry = {
  id: string;
  event: string;
  entity_kind: string | null;
  entity_id: string | null;
  actor_kind: 'customer' | 'staff' | 'system';
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  created_at: string;
};

export const customerActivityService = {
  async list(limit = 100): Promise<ActivityEntry[]> {
    const { data, error } = await supabase
      .from('audit_log')
      .select('id, event, entity_kind, entity_id, actor_kind, before, after, created_at')
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw new Error(`Could not load activity: ${error.message}`);
    return (data ?? []) as ActivityEntry[];
  },
};
